module.exports = __webpack_public_path__ + "img/a10581c.svg";